module.exports = __webpack_public_path__ + "static/33-818b487a1e6611428854d8016da84563.jpg";